import PicturePage from "./picture-page";
export default PicturePage
